var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m60.632 646.737c-33.486 0-60.632-27.146-60.632-60.632v-404.21c0-33.486 27.146-60.631 60.632-60.631h646.737c33.486 0 60.631 27.145 60.631 60.631v404.21c0 33.486-27.145 60.632-60.631 60.632zm0-60.631h646.737v-355.948l-280.926 162.21-40.037 26.132-40.017-26.132-285.757-164.978zm325.773-243.295 278.723-160.916h-557.447z"}));
}

Mail.defaultProps = {"height":"768","viewBox":"0 0 768 768","width":"768"};

module.exports = Mail;

Mail.default = Mail;
